module.exports = __webpack_public_path__ + "img/starryGLLogo.9b52ca9d.png";